<template lang="pug">
  .component-client-action-buttons
    ModalReveal
      button.button.warning(slot="trigger", type="button") Edit
      .row
        .columns
          label Name
            input(type="text", v-model="item.name")
          label Description
            input(type="text", v-model="item.description")
          label Attachment views
            .input-group(v-if="typeof item.attachment_views !== 'string'", v-for="(attachments, index) in item.attachment_views")
              input.input-group-field(type='text', v-model="item.attachment_views[index]")
              .input-group-button
                button.button.warning(@click="item.attachment_views.splice(index, 1)") -
          button.button.small(@click="item.attachment_views.push([])") Add view
        .columns
          .row
            .columns
              label Number required
              input(type="checkbox", v-model="item.has_number")
              br
              label Emission date required
              input(type="checkbox", v-model="item.has_emission")
              br
              label Expiry date required
              input(type="checkbox", v-model="item.has_expiry")
            .columns
              label Issuer required
              input(type="checkbox", v-model="item.has_issuer")
              br
              label Country required
              input(type="checkbox", v-model="item.has_country")
      .row.columns.text-center
        button.button(@click="edit") Update Toc Type

    button.button.warning(type="button", v-on:click="remove") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from 'src/maggieHelper'
  import ModalReveal from '../../foundation/ModalReveal'

  export default {
    name: 'DocumentTypeButtons',
    components: {ModalReveal},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>DT${this.item.id} document type?</strong>`, () => {
          KeplerBackofficeSdk.documentTypes.select(this.item).remove(() => {
            MaggieHelper.notification('delete-esit', 'Document type removed')
            window.location.reload()
          })
        })
      },
      edit() {
        this.$set(this.item, 'attachment_views', this.item.attachment_views.join(','))

        KeplerBackofficeSdk.documentTypes.select(this.item).edit(this.item, () => {
          window.location.reload()
        })
      }
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DocumentTypeButtons.vue?c6d0f000